import React, { FC, isValidElement, ReactNode } from "react";
import classNames from "classnames";
import { ScanPageBodyItemEnum, ScanPageRightProps, ScanPageRightItemEnum } from "../../interface";

const Right: FC<ScanPageRightProps> = props => {
  const { children, className, style, } = props;
  // const renderChildren = (childrenNodes: ReactNode): ReactNode => {
  //   return React.Children.map(childrenNodes, child => {
  //     const childElement = child as React.FunctionComponentElement<ScanPageRightProps>;
  //     if (!isValidElement(childElement)) return null;
  //     if (!childElement.type) return null;
  //     const { displayName } = childElement.type;
  //     if (displayName && displayName in ScanPageRightItemEnum) {
  //       return React.cloneElement(childElement);
  //     } else {
  //       console.error(
  //         'Warning: ScanPageRight has a child which is not a GoodInfo or GoodItem component',
  //       );
  //     }
  //   });
  // };
  const classes = classNames('scan-page-body-right', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

Right.displayName = ScanPageBodyItemEnum.Right;

export default Right;